var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrowth(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "growth"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 6V7.5H19.9394L13.5 13.9394L10.2802 10.7198C10.2106 10.6501 10.128 10.5948 10.037 10.5571C9.94601 10.5194 9.84849 10.5 9.75 10.5C9.65151 10.5 9.55399 10.5194 9.463 10.5571C9.37202 10.5948 9.28936 10.6501 9.21975 10.7198L1.5 18.4394L2.56058 19.5L9.75 12.3106L12.9697 15.5303C13.0394 15.5999 13.122 15.6552 13.213 15.6929C13.304 15.7306 13.4015 15.75 13.5 15.75C13.5985 15.75 13.696 15.7306 13.787 15.6929C13.878 15.6552 13.9606 15.5999 14.0303 15.5303L21 8.56057V13.5H22.5V6H15Z",
    fill: "#050A25"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/growth.633285dcbc8ebb7fcf70b37d62134b55.svg";
export { ForwardRef as ReactComponent };